export const isValidDigit = (value: string) => !isNaN(parseInt(value, 10));
